<template>
  <div class="main-content">
    <div class="head-navigate">
      <a-icon
        type="left"
        :style="{ fontSize: '20px', color: '#333' }"
        @click="backPage"
      />
      <span>物业管理</span>
    </div>
    <div class="select-menu" v-if="num>0">
      <div v-for="(item,index) in menuOption" :key="index" @click="navigatePage(item)" v-show="item.isHave">
        <img :src="item.icon" />
        <span>{{item.name}}</span>
      </div>
    </div>
    <div class="no-data" v-else>暂无菜单权限，请联系管理员！</div>
  </div>
</template>
<script>
import { gainAble } from "../axios/property";
export default {
  components: {},
  data() {
    return {
      menuOption: [
        {name: '房屋管理',icon: require('../assets/propertyImg/roomIcon.png'),route: '/room-list',isHave: true},
        {name: '客户管理',icon: require('../assets/propertyImg/clientIcon.png'),route: '/client-list',isHave: true},
        {name: '抄表管理',icon: require('../assets/propertyImg/copyIcon.png'),route: '/copy-list',isHave: true},
        {name: '工单管理',icon: require('../assets/propertyImg/orderIcon.png'),route: '/order-list',isHave: true},
      ],
      companyId: '',
      num: 0, // 菜单权限数量
    };
  },
  created(){
    console.log(this.$store.state.initialData)
    this.companyId = this.$store.state.initialData.companyId;
    this.gainPermission()
  },
  methods: {
    gainPermission(){ // 获取权限
      let that = this
      let permissionList = [];
      this.num = 0
      gainAble(this.companyId).then(res=>{
        console.log(res)
        if(res.data.code==0){
          permissionList = res.data.data
          for(let i=0;i<that.menuOption.length;i++){
            for(let j=0;j<permissionList.length;j++){
              console.log(that.menuOption[i].name)
              if(that.menuOption[i].name=='房屋管理'){
                if(permissionList[j].propertyResourceName=='楼宇'&&permissionList[j].rwAccessStatus!=0){
                  that.menuOption[i].isHave = true
                  that.menuOption[i].rwAccessStatus = permissionList[j].rwAccessStatus
                  this.num++
                  break;
                } else {
                  that.menuOption[i].isHave = false
                  that.menuOption[i].rwAccessStatus = permissionList[j].rwAccessStatus
                }
              } else if(that.menuOption[i].name=='抄表管理') {
                if(permissionList[j].propertyResourceName=='仪表'&&permissionList[j].rwAccessStatus!=0){
                  that.menuOption[i].isHave = true
                  that.menuOption[i].rwAccessStatus = permissionList[j].rwAccessStatus
                  this.num++
                  break;
                } else {
                  that.menuOption[i].isHave = false
                  that.menuOption[i].rwAccessStatus = permissionList[j].rwAccessStatus
                }
              } else {
                console.log(permissionList[j].propertyResourceName==that.menuOption[i].name)
                if(permissionList[j].propertyResourceName==that.menuOption[i].name.substring(0,2)&&permissionList[j].rwAccessStatus!=0){
                  that.menuOption[i].isHave = true
                  that.menuOption[i].rwAccessStatus = permissionList[j].rwAccessStatus
                  this.num++
                  break;
                } else {
                  that.menuOption[i].isHave = false
                  that.menuOption[i].rwAccessStatus = permissionList[j].rwAccessStatus
                }
              }
            }
          }
        }
        console.log(that.menuOption)
      })
    },
    backPage() {
      // 回退到app
      window.location.href = "jsToOc://back";
    },
    navigatePage(item){
      console.log(item)
      this.$store.state.initialData.currentPermission = item
      this.$router.push(item.route)
    }
  },
};
</script>
<style scoped>
.main-content {
  background-color: #f9f9f9;
}

.head-navigate {
  display: flex;
  align-items: center;
  background-color: white;
  padding: 0.2rem 0.3rem;
}
.head-navigate span {
  font-size: 17px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;
  color: #333333;
  margin: auto;
}
.select-menu{
  display:flex;
  flex-wrap:wrap;
  width: 95%;
  margin: 0 auto;
  margin-top: 0.5rem;
  background-color: #FFFFFF;
  border-radius: 8px;
  padding: 0.3rem 0;
}
.select-menu div{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 2% 3.5%;
}
.select-menu div img{
  width: 40px;
  height: 40px;
  margin-bottom: 0.2rem;
}
.no-data{
  width: 92%;
  margin: 0 auto;
  margin-top: 0.5rem;
  background-color: #FFFFFF;
  border-radius: 8px;
  padding: 0.3rem 0.4rem;
  font-weight: 700;
}
</style>
